import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableCashAdvanceHistory extends Layout {
    sourceIfuelCashOnCard: DataSource;
    tableCashAdvanceHistory: Table;
}
